class Header {
  menuMobileOpen = false
  openNavMobileClass = 'open-nav-mobile'
  showNavClass = 'show-nav'
  showSubNavClass = 'show-subnav'
  $megaMenuMobile = $('.megamenu-mobile')
  $burgerMenu = $('.burger-menu')
  calculHeight = []
  lastScrollTop = 0
  mobileBreakPoint = 1024

  constructor () {
    this.init()
  }

  calculMinHeight (megamenuId) {
    if (!this.calculHeight.includes(megamenuId)) {
      this.calculHeight.push(megamenuId)
      const $megamenu = $('.banner-megamenu-' + megamenuId)
      let height = 0
      $megamenu.find('.level-2').each((index, element) => {
        height = Math.max(height, $(element).height())
      })

      // console.log(height)
      $megamenu.css({ 'min-height': height + 100 })
    }
  }

  initCloseMegamenu () {
    const _this = this
    $(document).click(function (event) {
      if ($(event.target).closest('.banner').length === 0) {
        _this.closeMegaMenu()
      }
    })
  }

  openMegaMenu (menuId) {
    console.log('open megamenu')
    $(document).trigger('menu-open')
    // this.calculMinHeight(menuId)
    $('.navigation-principale-link.active').removeClass('active')
    $('.navigation-principale-link.submenu-open').removeClass('submenu-open')
    $('.navigation-principale-link-' + menuId).addClass('submenu-open')
    $('body').addClass('open-megamenu')
    $('.banner-megamenu.show').removeClass('show')
    $('.banner-megamenu.banner-megamenu-' + menuId).addClass('show')
    setTimeout(() => {
      $('.navigation-principale-link-' + menuId).addClass('active')
    }, 200)
  }

  closeMegaMenu () {
    const $navLinkActive = $('.navigation-principale-link.active')
    $('body').removeClass('open-megamenu')
    $('.banner-megamenu.show').removeClass('show')
    $navLinkActive.blur()
    $navLinkActive.removeClass('active')
    $('.navigation-principale-link.submenu-open').removeClass('submenu-open')
  }

  initHandleNavClick () {
    const _this = this
    const $navLink = $('.navigation-principale-link')
    const $navLevel2Link = $('.level-2-link')
    const $xButtonLink = $('.custom-navigation-push-content .x-button-link')
    const $navPushLink = $('.navigation-push-link')
    $navLink.click(function () {
      const $this = $(this)
      _this.handleNavClick($this)
    })

    $navLink.focus(function () {
      const $this = $(this)
      _this.handleNavClick($this)
    })

    $navLevel2Link.focus(function () {
      const parentId = $(this).closest('.sub-item').data('id-parent')
      const megaMenuId = $(this).closest('.banner-megamenu').data('id-parent')
      _this.handleNav2Hover(parentId)
      _this.openMegaMenu(megaMenuId)
    })

    $xButtonLink.focus(function () {
      const megaMenuId = $(this).closest('.banner-megamenu').data('id-parent')
      _this.openMegaMenu(megaMenuId)
    })

    $navPushLink.focus(function () {
      const megaMenuId = $(this).closest('.banner-megamenu').data('id-parent')
      _this.openMegaMenu(megaMenuId)
    })

    $(document).on('keydown', function (event) {
      if (event.which === 27) {
        _this.closeMegaMenu()
      }
    })
  }

  handleNavClick ($this) {
    const menuId = $this.attr('menu-id')

    if ($this.hasClass('active')) {
      this.closeMegaMenu()
    } else {
      this.openMegaMenu(menuId)
    }
  }

  initHandleLevel1LinkClick () {
    const level1LinkList = document.querySelectorAll('.banner-megamenu .level-1 a')

    level1LinkList.forEach((link) => {
      link.addEventListener('mouseover', (event) => {
        const currentId = event.currentTarget.getAttribute('data-id')
        this.handleNav2Hover(currentId)
      })

      link.addEventListener('focus', (event) => {
        const currentId = event.currentTarget.getAttribute('data-id')
        const megaMenuId = $(event.currentTarget).closest('.banner-megamenu').data('id-parent')
        this.handleNav2Hover(currentId)
        this.openMegaMenu(megaMenuId)
      })
    })

    /* $('.banner-megamenu').mouseleave(() => {
      $('.level-1-link.active').removeClass('active')
      $('.level-2.show').removeClass('show')
    }) */
  }

  handleNav2Hover (currentId) {
    const visibleElements = document.querySelectorAll('.banner-megamenu .level-2.show')
    const $currentSubitem = document.querySelector('.banner-megamenu .sub-item-' + currentId)
    $('.level-1-link.active').removeClass('active')
    $('.level-1-link-' + currentId).addClass('active')

    visibleElements.forEach(element => {
      element.classList.remove('show')
    })

    if ($currentSubitem) {
      $currentSubitem.classList.add('show')
    }
  }

  initMobileMenu () {
    const $burgerBtn = $('.banner-mobile-burger .burger-menu')

    $burgerBtn.click(() => {
      if (this.menuMobileOpen) {
        this.closeNavMobile()
      } else {
        this.openNavMobile()
      }
    })

    $('.navigation-principale-link').click((event) => {
      // console.log($(event.target).attr('menu-id'))
      const $target = $(event.currentTarget)
      if ($target.hasClass('has-children')) {
        this.openSubNavMobile($target.attr('menu-id'))
      }
    })

    $('.subnav-level1-title').click((event) => {
      const $titles = $('.subnav-level1-title')
      $titles.removeClass('open')
      $('.subnav-level2').slideUp()
      this.toggleAccordion($(event.currentTarget))
    })

    $('.megamenu-mobile-subnav-item-parent').click(() => {
      this.closeSubNavMobile()
    })
  }

  toggleAccordion ($title) {
    $title.toggleClass('open')
    $title.find('+ .subnav-level2').slideToggle()
  }

  openNavMobile () {
    $(document).trigger('menu-open')
    this.menuMobileOpen = true
    this.lastScrollTop = $(window).scrollTop()
    this.$burgerMenu.addClass('open')
    this.$megaMenuMobile.addClass(this.showNavClass)
    setTimeout(() => {
      $('body').addClass(this.openNavMobileClass)
    }, 300)
  }

  closeNavMobile () {
    this.menuMobileOpen = false
    this.closeSubNavMobile()
    $('body').removeClass(this.openNavMobileClass)
    if ($(window).width() < this.mobileBreakPoint) {
      $(document).scrollTop(this.lastScrollTop)
    }
    this.$burgerMenu.removeClass('open')
    this.$megaMenuMobile.removeClass(this.showNavClass)
  }

  openSubNavMobile (menuId) {
    this.$megaMenuMobile.find('.subnav-item-' + menuId).addClass('show')
    this.$megaMenuMobile.addClass(this.showSubNavClass)
  }

  closeSubNavMobile () {
    this.$megaMenuMobile.find('.megamenu-mobile-subnav-item.show').removeClass('show')
    this.$megaMenuMobile.removeClass(this.showSubNavClass)
  }

  initHandleScroll () {
    $(window).scroll(function () {
      const x = $(window).scrollTop()
      if (x <= 60) {
        $('body').removeClass('body-scroll')
      } else {
        $('body').addClass('body-scroll')
      }
    })
  }

  initResize () {
    $(window).resize(() => {
      if ($(window).width() > this.mobileBreakPoint) {
        this.closeNavMobile()
      }
    })
  }

  handleSearchOpen () {
    $(document).on('search-open', () => {
      this.closeNavMobile()
      this.closeMegaMenu()
    })
  }

  init () {
    this.initCloseMegamenu()
    this.initHandleNavClick()
    this.initHandleLevel1LinkClick()
    this.initMobileMenu()
    this.initHandleScroll()
    this.initResize()
    this.handleSearchOpen()
  }
}

export default Header
